import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BIGrey } from "../../assets/helpers";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const NoSuchPage = () => {
  let navigate = useNavigate();

  const { multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_NO_SUCH_PAGE_TITLE = English?.NoSuchPage?.TEXT_NO_SUCH_PAGE_TITLE,
    TEXT_NO_SUCH_PAGE_SUBHEADING_1 = English?.NoSuchPage?.TEXT_NO_SUCH_PAGE_SUBHEADING_1,
    TEXT_NO_SUCH_PAGE_SUBHEADING_2 = English?.NoSuchPage?.TEXT_NO_SUCH_PAGE_SUBHEADING_2
  } = multiLanguageData?.NoSuchPage || {};

  return (
    <Stack direction={"column"} justifyContent={"center"} alignItems={"center"}>
      <Typography variant="h4">{TEXT_NO_SUCH_PAGE_TITLE}</Typography>
      <Typography style={{ marginTop: "10px", color: BIGrey }}>
        {TEXT_NO_SUCH_PAGE_SUBHEADING_1}
      </Typography>
      <Button
        onClick={() => {
          navigate("/home");
        }}
        variant="contained"
        style={{ marginTop: "50px" }}>
        {TEXT_NO_SUCH_PAGE_SUBHEADING_2}
      </Button>
    </Stack>
  );
};

export default NoSuchPage;
